import { z } from 'zod';
import { BaseFlowDecorationSchema, FlowDecorationType } from './base.js';
import { FlowDecorationColor } from './constants.js';
export var FlowStickyNoteFontSize;
(function (FlowStickyNoteFontSize) {
    FlowStickyNoteFontSize["Small"] = "Small";
    FlowStickyNoteFontSize["Medium"] = "Medium";
    FlowStickyNoteFontSize["Large"] = "Large";
})(FlowStickyNoteFontSize || (FlowStickyNoteFontSize = {}));
export const FlowStickyNoteDataSchema = z.object({
    author: z.string().default(''),
    color: z.enum(FlowDecorationColor).default(FlowDecorationColor.Yellow),
    fontSize: z.enum(FlowStickyNoteFontSize).default(FlowStickyNoteFontSize.Medium),
    markdownContent: z.string().default(''),
});
export const FlowStickyNoteNodeSchema = BaseFlowDecorationSchema.extend({
    decorationType: z.literal(FlowDecorationType.StickyNote),
    data: FlowStickyNoteDataSchema,
    dimensions: z.object({
        width: z.number().default(240).optional(),
        height: z.number().default(240).optional(),
    }),
});
//# sourceMappingURL=stickyNotes.js.map